export const ProfessionalProfile = "prof-profile";
